import { IconButton, Tooltip } from '@mui/material';
import TableRow from '@mui/material/TableRow';
import { enqueueSnackbar } from 'notistack';
import AppTableCell from 'src/components/appComponents/table/AppTableCell';
import Iconify from 'src/components/iconify';
import { IMarketingDto } from 'src/types/marketing';

type Props = {
  row: IMarketingDto;
};

export default function MarketingTableRow({ row }: Props) {
  const handleCopy = () => {
    navigator.clipboard.writeText(row?.fullLink);
    enqueueSnackbar({
      variant: 'success',
      message: 'Link copied to clipboard',
      anchorOrigin: { vertical: 'top', horizontal: 'center' },
    });
  };

  return (
    <>
      <TableRow hover>
        <AppTableCell value={row?.id} />
        <AppTableCell value={row?.utmSource} />
        <AppTableCell value={row?.utmCampaign} />
        <AppTableCell value={row?.utmMedium} />
        <AppTableCell value={row?.type == 'GOOGLE' ? 'Android' : 'iPhone'} />
        <AppTableCell value={new Date(row?.createdAt)?.toLocaleDateString()} />
        <AppTableCell
          value={
            <Tooltip title="Copy Link" placement="bottom" arrow>
              <IconButton onClick={handleCopy}>
                <Iconify icon="icon-park-solid:copy-link" width="24" height="24" color="#51C1CF" />
              </IconButton>
            </Tooltip>
          }
        />
      </TableRow>
    </>
  );
}
